/* eslint-disable */

import React, { useState } from "react";
import TablePaginate from "components/TablePaginate/TablePaginate";
import { puushdotPoolService } from "../../services/puushdotPoolService";
import { useParams } from "react-router-dom";
import { formatTimestamp } from "../../helper/fommaters";

export default function PuushdotPoolActivity() {
  const { id } = useParams();
  const [size] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [items, setItems] = React.useState([]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Pool Id",
        accessor: "retroPool.poolId",
      },
      {
        Header: "Nft Contract",
        accessor: "retroPool.nftContract",
      },
      // {
      //   Header: "Price",
      //   accessor: "retroPool.price",
      // },
      {
        Header: "Type",
        accessor: "type",
      },

      {
        Header: "From",
        accessor: "from",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "Item",
        accessor: "item",
      },
      {
        Header: "Time",
        accessor: "time",
        Cell: function Tier(cell) {
          return formatTimestamp(cell.value);
        },
      },
    ],
    []
  );

  async function fetchPuushdotActivity(id) {
    const payload = {
      page,
      size,
      sortBy: "createdAt",
      sortType: "asc",
    };
    try {
      const { data } = await puushdotPoolService.listActivity(id, payload);
      setItems(data.items);
      setCount(+data.paginate.count);
      setPage(+data.paginate.page);
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    fetchPuushdotActivity(id);
  }, [page]);

  return (
    <div>
      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />
    </div>
  );
}
